import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';

import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { SelectSearchFormField } from '@/components/form/SelectSearchFormField.comp.tsx';
import { TextFormField } from '@/components/form/TextFormField.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { ProcessCalendarEntryQueryForm } from '@/views/processes/calendarEntryQuery/ProcessCalendarEntryQueryForm.comp.tsx';
import { SelectCustomerOrContactForProcess } from '@/views/processesCreate/components/customerOrContact/SelectCustomerOrContactForProcess.comp.tsx';
import { SelectCustomerOrContactForProcessEditWrapper } from '@/views/processesCreate/components/customerOrContact/SelectCustomerOrContactForProcessEditWrapper.comp.tsx';
import { ProcessCreateFormAssignContactOwnerAsProcessOwnerButton } from '@/views/processesCreate/components/ProcessCreateFormAssignContactOwnerAsProcessOwnerButton.comp.tsx';
import { ProcessCreateFormOfferSection } from '@/views/processesCreate/components/ProcessCreateFormOfferSection.comp.tsx';
import { ProcessCreateOfferState } from '@/views/processesCreate/util/useProcessCreateOffer.util.ts';

interface Props {
  calendarEntryQueryOptions: Omit<
    React.ComponentProps<typeof ProcessCalendarEntryQueryForm>,
    'disabled'
  >;
  disabled: boolean;
  offer: ProcessCreateOfferState;
  /** Called on a user edit of the name, so the dialog stops naming the process automatically. */
  onNameChange: () => void;
  usersOptions: SelectSearchOptionModel[];
}

export const ProcessCreateForm: React.FC<Props> = props => {
  const { t } = useTranslationWithPrefix('views.processesCreate');
  const { calendarEntryQueryOptions, disabled, offer, onNameChange, usersOptions } = props;

  return (
    <Stack spacing={2}>
      <Grid container spacing={2}>
        <Grid size={{ md: 6, xs: 12 }}>
          <TextFormField
            disabled={disabled}
            helperText={t('form.nameHint')}
            label={t('form.name')}
            name="name"
            onChangeNotStopping={onNameChange}
            placeholder={t('form.namePlaceholder')}
          />
        </Grid>
        <Grid size={{ md: 6, xs: 12 }}>
          <ProcessCreateFormAssignContactOwnerAsProcessOwnerButton>
            <SelectSearchFormField
              disabled={disabled}
              label={t('form.processOwnerId')}
              name="processOwnerId"
              options={usersOptions}
            />
          </ProcessCreateFormAssignContactOwnerAsProcessOwnerButton>
        </Grid>
        <Grid size={12}>
          <ProcessCalendarEntryQueryForm disabled={disabled} {...calendarEntryQueryOptions} />
        </Grid>
        {offer.status !== 'hidden' && (
          <Grid size={12}>
            <ProcessCreateFormOfferSection disabled={disabled} offer={offer} />
          </Grid>
        )}
        <Grid size={12}>
          <TextFormField
            disabled={disabled}
            label={t('form.description')}
            minRows={3}
            multiline
            name="description"
          />
        </Grid>
        <Grid size={12}>
          <TextFormField
            disabled={disabled}
            label={t('form.noteText')}
            minRows={3}
            multiline
            name="noteText"
          />
        </Grid>
      </Grid>
      <SelectCustomerOrContactForProcessEditWrapper Component={SelectCustomerOrContactForProcess} />
    </Stack>
  );
};
